import axiosServices from "../utils/axios";
import { convertToCamelCase } from "../utils/code-utils";

import type { PhoneDirectory } from "../utils/types/phoneDirectory";

interface FetchApiResponce {
  data: PhoneDirectory[];
  total: number;
}

interface FetchPhoneDirectoryParams {
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const fetchPhoneDirectoryList = async ({
  search,
  page = 0,
  limit = 20,
  sortBy,
  sortOrder = "asc",
}: FetchPhoneDirectoryParams) => {
  const response = await axiosServices.get<FetchApiResponce>(
    "/phonedirectory",
    {
      params: {
        q: search,
        page,
        limit,
        sortBy,
        sortOrder,
      },
    }
  );
  const result = convertToCamelCase<PhoneDirectory[]>(response.data.data);
  return {
    data: result,
    total: response.data.total,
  };
};
